import {type OrganizedSettings} from '../../PanelBank/types';
import {useSectionSettingsContextMaybe} from '../../WorkspaceDrawer/Settings/SectionSettingsContextProvider';
import {usePanelContext} from '../PanelContextProvider';

/**
 * Inherited (workspace → section) settings for the current panel.
 *
 * Reports pass `inheritedSettings` into PanelContextProvider directly. In
 * workspaces the value is read from SectionSettingsContext here, at the
 * point of use, so that panel wrappers (e.g. WorkspacePanel's memo boundary)
 * don't subscribe to it on behalf of panels that never read it.
 */
export const useInheritedSettings = (): OrganizedSettings | undefined => {
  const {inheritedSettings} = usePanelContext();
  const sectionInheritedSettings =
    useSectionSettingsContextMaybe()?.inheritedSettings;
  return inheritedSettings ?? sectionInheritedSettings;
};
